var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionInInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#FFDB00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4149 11.8397H5.5L6.37873 10.2397L14.4149 10.2397V11.8397Z",
    fill: "#011627"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.781 7L16.4999 11L12.781 15H10.5425L14.2614 11L10.5425 7H12.781Z",
    fill: "#011627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionInInput);
export default __webpack_public_path__ + "static/media/action-in-input.b90ed73b8f3a72f67104310bc06eb311.svg";
export { ForwardRef as ReactComponent };